import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchRecommendedListings = () =>
  axios
    .get(`${BASE_URL}/recommendations/listings`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchActiveComps = (listingId) =>
  axios
    .get(`${BASE_URL}/recommendations/active_comparisons?listing_id=${listingId}`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchSoldComps = (listingId) =>
  axios
    .get(`${BASE_URL}/recommendations/sold_comparisons?listing_id=${listingId}`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchMarketComparison = (listingId, radius = 25) =>
  axios
    .get(`${BASE_URL}/recommendations/overview?listing_id=${listingId}&radius=${radius}`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchMarketplaceTaskStatus = () =>
  axios
    .get(`${BASE_URL}/dealership/marketplace-task-status`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const runMarketplaceListingRecommendations = (dealerId) =>
  axios
    .post(`${BASE_URL}/marketplace/listing_recommendations`, {
      dealer_id: dealerId,
    }, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);